export const UI_START_LOADING = "UI_START_LOADING"
export const UI_STOP_LOADING = "UI_STOP_LOADING"

// products
export const SET_PRODUCTS = "SET_PRODUCTS"
export const SET_PRODUCT = "SET_PRODUCT"
export const SET_PRODUCTS_CART = "SET_PRODUCTS_CART"

// gallery
export const SET_GALLERY = "SET_GALLERY"

// projects
export const SET_PROJECTS = "SET_PROJECTS"
export const SET_PROJECT = "SET_PROJECT"

// blog
export const SET_BLOG = "SET_BLOG"
export const SET_BLOGS = "SET_BLOGS"

// events
export const SET_EVENTS = "SET_EVENTS"
export const SET_EVENT = "SET_EVENT"

// teamMembers
export const SET_TEAM_MEMBERS = "SET_TEAM_MEMBERS"
export const SET_TEAM_MEMBER = "SET_TEAM_MEMBER"

// states
export const SET_STATES = "SET_STATES"
export const SET_STATE = "SET_STATE"